const collegeEvent = state => state.collegeEvent;

const collegeListEvent = state => state.collegeListEvent;

const collegeEvents = state => state.collegeEvents;

const collegeTeamEvents = state => state.collegeTeamEvents;

const collegeListEvents = state => state.collegeListEvents;

const collegeEventLoading = state => state.collegeEventLoading;

const collegeEventsLoading = state => state.collegeEventsLoading;

const collegeEventsMeta = state => state.meta;

const collegeEventsLimited = state => state.collegeEventsLimited

export default {
  collegeEvent,
  collegeListEvent,
  collegeEvents,
  collegeListEvents,
  collegeEventLoading,
  collegeEventsLoading,
  collegeEventsMeta,
  collegeEventsLimited,
  collegeTeamEvents
};
